import {Card, Col, Row, Tag} from "antd";
import {useMemo, useEffect} from "react";
import {statusColors} from "../constants";
import { useSelector} from "react-redux";
import { selectPo} from "../../../redux/slices/purchassingOrder";

export default function POCard({onClick, item}) {

    const {list } = useSelector(selectPo);
    // console.log("liste  "+  JSON.stringify(list))
    // console.log(list)
    const {ref, vendor, warehouse, cost, createdAt, status, deliveryType, username, Currency} = item

    const poRef = useMemo(() => {
        const toString = String(ref);
        const numberOfZero = 8 - toString.length;
        return `Po-${'0'.repeat(numberOfZero)}${toString}`
    }, [ref]);

    useEffect(() => {
        
      }, []);

    // const totalCost = useMemo(() => {

    //     let total = 0;

    //     for (const { amount} of list) {
            
    //         total += amount;
    //     }

    //     return (total || 0)?.toFixed(2)

    // }, [list]);

    // const totalCosts = useMemo(() => {

    //     let total = 0;
    //     list.Purchases?.forEach(  e =>{
    //         e.Purchases.forEach(e =>
    //             {
    //                 total += e.Amount
    //             })
    //     })

    //     return total;

    // }, [list])

    // console.log("fff" , totalCosts)

    
    const handleClick = () => {
        onClick && onClick()
    }
    // console.log("totalCost totalCost" + JSON.stringify(totalCost));
    // console.log("cost cost" + JSON.stringify(item));

    return (
        <Col className='m-2'>
            <Card style={{width: 400, cursor: "pointer", boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)"}}
                  onClick={handleClick}>
                <Row>
                    <Col>
                        <Row>
                            <p className='text-muted'>
                                {poRef}
                            </p>
                        </Row>

                        <Row>
                            <h5 className='text-truncate mb-2' style={{width:240}}>
                                {`${vendor} - ${warehouse}`}
                            </h5>
                        </Row>

                        <Row>
                            {
                                cost && (
                                    <Col className='mr-3'>
                                     {cost} 
                                    </Col>
                                )
                            }

                            <Col>
                                <small className='text-muted'>
                                    {createdAt}
                                </small>
                            </Col>

                        </Row>

                    </Col>

                    <Col className='ml-auto'>
                        <Row>
                            <Tag color={statusColors(status)}>{status}</Tag>
                        </Row>

                        <Row className='mt-4'>
                            <Tag color='green'>{deliveryType}</Tag>
                        </Row>

                        <Row className='mt-3'>
                            <p className='text-muted'>{username}</p>
                        </Row>

                    </Col>
                </Row>
            </Card>
        </Col>
    )
}
